import { useNavigate } from 'react-router-dom';
import { DrawerSection } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { useWorkQueueContext } from '../../../context/useWorkQueueContext.js';
import { WORK_QUEUE_PATHS } from '../../../constants/inboxViews.js';
import { ArrowUpRight } from 'lucide-react';

/** Preview + link to the event this question is attached to. */
function LinkedEventPreview({ linkedEvent }) {
  const { t } = useTranslation('work-queues-app');
  const navigate = useNavigate();
  const { clearFilters } = useWorkQueueContext();
  if (!linkedEvent) return null;

  const handleOpenLinkedEvent = () => {
    clearFilters();
    navigate(WORK_QUEUE_PATHS.event(linkedEvent.id));
  };

  return (
    <DrawerSection title={t('question.linkedEvent')}>
      <button
        type="button"
        onClick={handleOpenLinkedEvent}
        className="flex w-full items-center justify-between gap-3 rounded-lg border border-edge px-4 py-3 text-left transition-colors hover:bg-surface-hover"
      >
        <span className="min-w-0">
          <span className="font-mono text-xs text-content-faint">{linkedEvent.id}</span>
          <span className="mt-0.5 block truncate text-sm font-medium text-content">
            {linkedEvent.title}
          </span>
        </span>
        <ArrowUpRight size={16} className="flex-shrink-0 text-content-muted" />
      </button>
    </DrawerSection>
  );
}

export default LinkedEventPreview;
